import type { Building, FactionId, Language } from "../core/types";

/** Names describe the same four rules; each civilization has its own architecture. */
export const STRUCTURES: Record<
  FactionId,
  Record<Building, readonly [string, string]>
> = {
  alliance: {
    mine: ["Helion Foundry", "Helion-Raffinerie"],
    research: ["Kepler Institute", "Kepler-Institut"],
    bastion: ["Bulwark Citadel", "Bollwerk-Zitadelle"],
    grid: ["Sentinel Lattice", "Wächtergitter"],
  },
  greys: {
    mine: ["Graviton Siphon", "Graviton-Siphon"],
    research: ["Cognition Spire", "Kognitionsspitze"],
    bastion: ["Null Bastion", "Nullbastion"],
    grid: ["Phase Matrix", "Phasenmatrix"],
  },
  reptiloids: {
    mine: ["Obsidian Drillworks", "Obsidian-Bohrwerk"],
    research: ["Sunforge Laboratory", "Sonnenschmiede-Labor"],
    bastion: ["Scalehold", "Schuppenfeste"],
    grid: ["Fang Array", "Fangbatterie"],
  },
  okalani: {
    mine: ["Tidal Extractor", "Gezeitenextraktor"],
    research: ["Chorus Observatory", "Chor-Observatorium"],
    bastion: ["Pearl Citadel", "Perlenzitadelle"],
    grid: ["Reef Aegis", "Riffschild"],
  },
  xilur: {
    mine: ["Imperial Crucible", "Imperialer Schmelzofen"],
    research: ["Dynastic Archive", "Dynastisches Archiv"],
    bastion: ["Throne Bastion", "Thronbastion"],
    grid: ["Edict Battery", "Ediktbatterie"],
  },
  nocturn: {
    mine: ["Umbral Harvester", "Schattenharvester"],
    research: ["Void Sanctum", "Leerenheiligtum"],
    bastion: ["Eclipse Keep", "Eklipsenfeste"],
    grid: ["Nightveil Grid", "Nachtschleiergitter"],
  },
};

export const buildingName = (f: FactionId, b: Building, language: Language) =>
  STRUCTURES[f][b][language === "de" ? 1 : 0];

export const buildingAsset = (f: FactionId, b: Building) =>
  `stations/factions/${f}/${b}.webp`;
